import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, HardHat, ClipboardList, Home, Wrench, Briefcase, Server, ArrowRight } from 'lucide-react';
import { services } from '../mockData';

const iconMap = {
  Building2,
  HardHat,
  ClipboardList,
  Home,
  Wrench,
  Briefcase,
  Server
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-gray-50 relative">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-4">
            Our <span className="text-brand-red">Services</span>
          </h2>
          <p className="text-xl text-gray-600">
            Comprehensive solutions across construction, engineering, and industrial sectors
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="bg-white rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 group border border-gray-100 hover:border-brand-red hover:-translate-y-2"
                style={{
                  animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
                }}
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-red-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-brand-red transition-colors">
                  <Icon className="w-8 h-8 text-brand-red group-hover:text-white transition-colors" />
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-charcoal mb-3 group-hover:text-brand-red transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Features */}
                <ul className="space-y-2 mb-6">
                  {service.features.slice(0, 4).map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-600">
                      <div className="w-1.5 h-1.5 bg-brand-red rounded-full mr-2"></div>
                      {feature}
                    </li>
                  ))}
                </ul>

                {/* Learn More Link */}
                <Link to="/services" data-testid={`home-service-learn-more-${service.id}`} className="flex items-center text-brand-red font-semibold text-sm group-hover:gap-2 transition-all">
                  Learn More
                  <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
